import { twMerge } from 'tailwind-merge';

import { bodyTextLarge } from '@/styles/styles';
import Steps, { Step } from '@/components/ui/custom/Steps/Steps';
import { StepInformation } from './info/CourseStudioInfo.hooks';

type Props = {
  step: number;
  steps: Step[];
  stepsComponents: StepInformation[];
  disabled?: boolean;
};

export default function CourseStudioSteps(props: Props) {
  const { step, steps, stepsComponents, disabled } = props;

  return (
    <nav className="flex flex-col gap-2.5">
      <Steps
        disabled={disabled}
        activeStep={step}
        hideIndicator
        steps={steps}
        className={{
          base: 'py-0',
          active: 'bg-primary border-none text-base-100',
          done: 'bg-primary border-primary text-base-100',
          doneLine: 'bg-primary border-primary',
          todoLine: 'bg-primary-content border-primary-content',
          todo: 'bg-primary-content border-primary-content text-primary',
          success: 'bg-primary border-primary text-primary-content',
          step: 'hover:scale-75',
        }}
      />
      <div className="flex justify-center">
        <p
          className={twMerge(
            bodyTextLarge,
            'text-primary font-500 self-center grow text-center',
          )}
        >
          {stepsComponents[step].title}
        </p>
        <div className="flex justify-end">{stepsComponents[step].actions}</div>
      </div>
    </nav>
  );
}
